import { Button, Input, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function SaveCoverModal({
  open,
  onClose,
  onSave,
  defaultCoverName,
}) {
  const { t } = useTranslation()
  const [coverName, setCoverName] = useState('')

  useEffect(() => {
    setCoverName(defaultCoverName || 'My Cover')
  }, [defaultCoverName])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      closable
      title={t('save_as')}
      footer={
        <>
          <Button className="btn-white btn-dash" onClick={onClose}>
            Cancel
          </Button>
          <Button
            className="btn-blue btn-dash"
            disabled={!coverName}
            onClick={() => onSave(coverName)}
          >
            {t('save')}
          </Button>
        </>
      }
    >
      <div>
        <Input
          size="large"
          className="mb-3"
          placeholder={t('your_template_name')}
          value={coverName}
          onChange={(e) => setCoverName(e.target.value)}
          autoFocus
        />
      </div>
    </Modal>
  )
}
